// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + ({"3187":"download.list","9690":"consultant.list"}[chunkId] || chunkId) + "." + {"590":"e1e26269","3187":"8807abec","3688":"29035117","9472":"e34be1d0","9690":"e1e26269"}[chunkId] + ".chunk.css";
};